import { NavigationStep } from "./types";
import { SocialUser, StatusInfo, SystemSearch, TravelCompass, TravelHouse, } from "@s7/icons";
export var getItems = function (profileHref) { return [
    {
        title: "com.s7.tab.navigation.main.page",
        value: NavigationStep.MAIN,
        href: "/",
        icon: TravelHouse,
        as: "a",
    },
    {
        title: "com.s7.tab.navigation.trips.page",
        value: NavigationStep.TRIPS,
        href: "/?tab=".concat(NavigationStep.TRIPS),
        icon: TravelCompass,
        as: "a",
    },
    {
        title: "com.s7.tab.navigation.search.page",
        value: NavigationStep.SEARCH,
        href: "/?tab=".concat(NavigationStep.SEARCH),
        icon: SystemSearch,
        as: "a",
    },
    {
        title: "com.s7.tab.navigation.info.page",
        value: NavigationStep.INFO,
        href: "/?tab=".concat(NavigationStep.INFO),
        icon: StatusInfo,
        as: "a",
    },
    {
        title: "com.s7.tab.navigation.profile.page",
        value: NavigationStep.PROFILE,
        href: profileHref,
        icon: SocialUser,
        as: "a",
    },
]; };
export var LITE_PATH = "/lite/";
